import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { AppError } from "../app-error/app-error.model";
import { TransactionFilter } from "../wallet/wallet.model";

import { AAMS_ACTION_TYPE, AamsDataAction } from "./aams-data.action";
import { GameRoundFilter } from "./aams-data.model";
import { AamsDataService } from "./aams-data.service";

@Injectable()
export class AamsDataEffect {
	getLastGameRound$ = createEffect(() =>
		this.actions$.pipe(
			ofType(AAMS_ACTION_TYPE.getLastGameRound),
			map((x: ActionWithPayload<GameRoundFilter>) => x.payload),
			switchMap((gameRoundFilter) =>
				this.service.getLastGameRound(gameRoundFilter).pipe(
					map((response) => this.action.getLastGameRoundSuccess(response)),
					catchError((response: AppError) => of(this.action.getLastGameRoundFail(response)))
				)
			)
		)
	);

	getTransactions$ = createEffect(() =>
		this.actions$.pipe(
			ofType(AAMS_ACTION_TYPE.getTransactions),
			map((x: ActionWithPayload<TransactionFilter>) => x.payload),
			switchMap((transactionFilter) =>
				this.service.getTransactions(transactionFilter).pipe(
					map((response) => this.action.getTransactionsSuccess(response)),
					catchError((response: AppError) => of(this.action.getTransactionsFail(response)))
				)
			)
		)
	);

	getSessions$ = createEffect(() =>
		this.actions$.pipe(
			ofType(AAMS_ACTION_TYPE.getSessions),
			map((x: ActionWithPayload<TransactionFilter>) => x.payload),
			switchMap((transactionFilter) =>
				this.service.getSessions(transactionFilter).pipe(
					map((response) => this.action.getSessionsSuccess(response)),
					catchError((response: AppError) => of(this.action.getSessionsFail(response)))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private action: AamsDataAction,
		private service: AamsDataService
	) {}
}
